import { Flex, Form, Upload, Avatar, Button, message } from "antd";
import UploadUtils from "./Upload";
import { IconUpload, IconX } from "@tabler/icons-react";
import { Dispatch, SetStateAction } from "react";
import FormItemLabel from "antd/es/form/FormItemLabel";
import placeholder from "../assets/placeholder_thumbnail.png";

const ProfileUploader = ({
  image,
  setImage,
  setUploadStatus,
  uploadStatus,
  name,
  label,
}: {
  image: string | null;
  name: string;
  uploadStatus: boolean;
  setImage: Dispatch<SetStateAction<string | null>>;
  setUploadStatus: Dispatch<SetStateAction<boolean>>;
  label: string;
}) => {
  return (
    <>
      <FormItemLabel prefixCls="" required={false} label={label} />
      <Flex
        gap={15}
        align="center"
        className="pt-[4px!important] pb-[24px!important] "
      >
        <Avatar src={image ?? placeholder} size={60} />
        <Form.Item
          name={name}
          {...UploadUtils.formItemProps}
          className="mb-[0!important]"
        >
          <Upload
                        {...UploadUtils.buttonTypeProps} beforeUpload={(file: File) => { const allowedTypes = ["image/jpeg", "image/jpg", "image/png", "image/svg+xml", "application/pdf"]; const isValidType = allowedTypes.includes(file.type); const isValidSize = file.size <= 5 * 1024 * 1024; if (!isValidType) { message.error(`${file.name} must be JPG, JPEG, PNG, SVG or PDF`); } if (!isValidSize) { message.error(`${file.name} exceeds 5 MB size limit`); } return isValidType && isValidSize ? true : Upload.LIST_IGNORE; }} accept="image/jpeg,image/jpg,image/png,image/svg+xml"
            onChange={(info) => {
              setUploadStatus(() =>
                info.file.status === "uploading" ? true : false,
              );
              if (info.file.status === "done") {
                setImage(info?.file?.response?.[0]?.url);
              }
            }}
          >
            <Button disabled={uploadStatus} icon={<IconUpload size={16} />}>
              {uploadStatus ? "uploading...." : "Upload"}
            </Button>
          </Upload>
        </Form.Item>
        {image && (
          <Button
            danger
            type="text"
            icon={<IconX size={16} />}
            onClick={() => {
              setImage(null);
            }}
          >
            Remove
          </Button>
        )}
      </Flex>
    </>
  );
};

export default ProfileUploader;
